import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _approveMemberRequest = {};
var _approveMemberResponse = { member: '_member' };
var _blockMemberRequest = {};
var _blockMemberResponse = { member: '_member' };
var _bulkApproveMembersRequest = {};
var _bulkApproveMembersResponse = {};
var _bulkBlockMembersRequest = {};
var _bulkBlockMembersResponse = {};
var _bulkDeleteMembersByFilterRequest = {};
var _bulkDeleteMembersByFilterResponse = {};
var _bulkDeleteMembersRequest = {};
var _bulkDeleteMembersResponse = {};
var _createMemberRequest = { member: '_member' };
var _createMemberResponse = { member: '_member' };
var _deleteMemberAddressesRequest = {};
var _deleteMemberAddressesResponse = { member: '_member' };
var _deleteMemberEmailsRequest = {};
var _deleteMemberEmailsResponse = { member: '_member' };
var _deleteMemberPhonesRequest = {};
var _deleteMemberPhonesResponse = { member: '_member' };
var _deleteMemberRequest = {};
var _deleteMemberResponse = {};
var _deleteMyMemberRequest = {};
var _deleteMyMemberResponse = {};
var _disconnectMemberRequest = {};
var _disconnectMemberResponse = { member: '_member' };
var _getMemberRequest = {};
var _getMemberResponse = { member: '_member' };
var _getMyMemberRequest = {};
var _getMyMemberResponse = { member: '_member' };
var _joinCommunityRequest = {};
var _joinCommunityResponse = { member: '_member' };
var _leaveCommunityRequest = {};
var _leaveCommunityResponse = { member: '_member' };
var _listMembersRequest = {};
var _listMembersResponse = { members: '_member' };
var _member = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    lastLoginDate: 'google.protobuf.Timestamp',
};
var _muteMemberRequest = {};
var _muteMemberResponse = { member: '_member' };
var _queryMembersRequest = {};
var _queryMembersResponse = { members: '_member' };
var _unmuteMemberRequest = {};
var _unmuteMemberResponse = { member: '_member' };
var _updateMemberRequest = { member: '_member' };
var _updateMemberResponse = { member: '_member' };
var _updateMemberSlugRequest = {};
var _updateMemberSlugResponse = { member: '_member' };
var _updateMySlugRequest = {};
var _updateMySlugResponse = { member: '_member' };
function resolveComWixpressMembersApiMembersUrl(opts) {
    var domainToMappings = {
        'www.wixapis.com': [
            {
                srcPath: '/members/v1/members',
                destPath: '/v1/members',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/members-ng-api',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/members/v1/members',
                destPath: '/v1/members',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/members/v1/members',
                destPath: '/v1/members',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/members/v1/members',
                destPath: '/v1/members',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/members/v1/members',
                destPath: '/v1/members',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/members/v1/members',
                destPath: '/v1/members',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/members/v1/members',
                destPath: '/v1/members',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/members/v1/members',
                destPath: '/v1/members',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/members/v1/members',
                destPath: '/v1/members',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/members/v1/members',
                destPath: '/v1/members',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/members/v1/members',
                destPath: '/v1/members',
            },
        ],
        _: [
            {
                srcPath: '/_api/members/v1/members',
                destPath: '/v1/members',
            },
        ],
        'members.wixapps.net': [
            {
                srcPath: '/_api/members/v1/members',
                destPath: '/v1/members',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Updates the current member's slug.
 *
 * >**Note:**
 * >This method requires [visitor or member authentication](https://dev.wix.com/docs/build-apps/develop-your-app/access/about-identities).
 */
export function updateMySlug(payload) {
    var _a = serializer(_updateMySlugRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateMySlugResponse, { _member: _member }).fromJSON;
    function __updateMySlug(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.member',
            method: 'POST',
            methodFqn: 'com.wixpress.members.api.Members.UpdateMySlug',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersApiMembersUrl({
                protoPath: '/v1/members/my/slug',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateMySlug.fromReq = fromReq;
    __updateMySlug.__isAmbassador = true;
    return __updateMySlug;
}
/** Updates a member's slug. */
export function updateMemberSlug(payload) {
    var _a = serializer(_updateMemberSlugRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateMemberSlugResponse, {
        _member: _member,
    }).fromJSON;
    function __updateMemberSlug(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.member',
            method: 'POST',
            methodFqn: 'com.wixpress.members.api.Members.UpdateMemberSlug',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersApiMembersUrl({
                protoPath: '/v1/members/{id}/slug',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateMemberSlug.fromReq = fromReq;
    __updateMemberSlug.__isAmbassador = true;
    return __updateMemberSlug;
}
/**
 * Joins the current member to the site community and sets their profile to public.
 *
 * When a member's profile is public, they have access to the site's
 * [Members Area](https://support.wix.com/en/article/site-members-about-the-members-area)
 * features, such as chat, forum, and followers.
 * Their profile is visible to other members and site visitors.
 *
 * >**Note:**
 * >This method requires [visitor or member authentication](https://dev.wix.com/docs/build-apps/develop-your-app/access/about-identities).
 */
export function joinCommunity(payload) {
    var _a = serializer(_joinCommunityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_joinCommunityResponse, { _member: _member }).fromJSON;
    function __joinCommunity(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.member',
            method: 'POST',
            methodFqn: 'com.wixpress.members.api.Members.JoinCommunity',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersApiMembersUrl({
                protoPath: '/v1/members/join-community',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __joinCommunity.fromReq = fromReq;
    __joinCommunity.__isAmbassador = true;
    return __joinCommunity;
}
/**
 * Removes the current member from the site community and sets their profile to private.
 *
 * When a member's profile is private,
 * they do not have access to the site's
 * [Members Area](https://support.wix.com/en/article/site-members-about-the-members-area)
 * features, such as chat, forum, and followers.
 * Their profile is hidden from other members and site visitors.
 *
 * > **Notes:**
 * > - If a member leaves the site's community, their content (such as forum posts and blog comments) remain publicly visible.
 * > - This method requires [visitor or member authentication](https://dev.wix.com/docs/build-apps/develop-your-app/access/about-identities).
 */
export function leaveCommunity(payload) {
    var _a = serializer(_leaveCommunityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_leaveCommunityResponse, {
        _member: _member,
    }).fromJSON;
    function __leaveCommunity(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.member',
            method: 'POST',
            methodFqn: 'com.wixpress.members.api.Members.LeaveCommunity',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersApiMembersUrl({
                protoPath: '/v1/members/leave-community',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __leaveCommunity.fromReq = fromReq;
    __leaveCommunity.__isAmbassador = true;
    return __leaveCommunity;
}
/**
 * Retrieves the current member.
 *
 * >**Note:**
 * >This method requires [visitor or member authentication](https://dev.wix.com/docs/build-apps/develop-your-app/access/about-identities).
 */
export function getMyMember(payload) {
    var _a = serializer(_getMyMemberRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getMyMemberResponse, { _member: _member }).fromJSON;
    function __getMyMember(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.member',
            method: 'GET',
            methodFqn: 'com.wixpress.members.api.Members.GetMyMember',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersApiMembersUrl({
                protoPath: '/v1/members/my',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getMyMember.fromReq = fromReq;
    __getMyMember.__isAmbassador = true;
    return __getMyMember;
}
/**
 * Retrieves a member by ID.
 *
 * Members are typically associated with a contact, each having a distinct member ID and contact ID. When specifying the ID as a parameter, don't presume the IDs are identical since they represent separate entities.
 */
export function getMember(payload) {
    var _a = serializer(_getMemberRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getMemberResponse, { _member: _member }).fromJSON;
    function __getMember(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.member',
            method: 'GET',
            methodFqn: 'com.wixpress.members.api.Members.GetMember',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersApiMembersUrl({
                protoPath: '/v1/members/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getMember.fromReq = fromReq;
    __getMember.__isAmbassador = true;
    return __getMember;
}
/** Lists site members, given the provided paging and fieldsets. */
export function listMembers(payload) {
    var _a = serializer(_listMembersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listMembersResponse, { _member: _member }).fromJSON;
    function __listMembers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.member',
            method: 'GET',
            methodFqn: 'com.wixpress.members.api.Members.ListMembers',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersApiMembersUrl({
                protoPath: '/v1/members',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData, true),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listMembers.fromReq = fromReq;
    __listMembers.__isAmbassador = true;
    return __listMembers;
}
/**
 * Retrieves a list of up to 100 members, given the specified filters, fieldsets, sorting, and paging.
 *
 * For field support for filters and sorting, see [Members: Supported Filters and Sorting](https://dev.wix.com/docs/rest/crm/members-contacts/members/members/filter-and-sort).
 *
 * To learn about working with _Query_ methods, see [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language),
 * [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging),
 * and [Field Projection](https://dev.wix.com/docs/rest/articles/getting-started/field-projection).
 */
export function queryMembers(payload) {
    var _a = serializer(_queryMembersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryMembersResponse, { _member: _member }).fromJSON;
    function __queryMembers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.member',
            method: 'POST',
            methodFqn: 'com.wixpress.members.api.Members.QueryMembers',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersApiMembersUrl({
                protoPath: '/v1/members/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryMembers.fromReq = fromReq;
    __queryMembers.__isAmbassador = true;
    return __queryMembers;
}
/**
 * Mutes a member.
 *
 * Muted members can't engage with a community. For example, they can't leave comments, like posts or comments, or share content.
 *
 * You can mute members in [Wix Blog](https://dev.wix.com/docs/rest/business-solutions/blog/introduction) and [Wix Forum](https://dev.wix.com/docs/rest/business-solutions/forum/introduction).
 */
export function muteMember(payload) {
    var _a = serializer(_muteMemberRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_muteMemberResponse, { _member: _member }).fromJSON;
    function __muteMember(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.member',
            method: 'POST',
            methodFqn: 'com.wixpress.members.api.Members.MuteMember',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersApiMembersUrl({
                protoPath: '/v1/members/{id}/mute',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __muteMember.fromReq = fromReq;
    __muteMember.__isAmbassador = true;
    return __muteMember;
}
/**
 * Unmutes a member.
 *
 * Unmuted members can engage with the community. For example, leave comments, like posts or comments, and share content.
 *
 * You can unmute members in [Wix Blog](https://dev.wix.com/docs/rest/business-solutions/blog/introduction) and [Wix Forum](https://dev.wix.com/docs/rest/business-solutions/forum/introduction).
 */
export function unmuteMember(payload) {
    var _a = serializer(_unmuteMemberRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_unmuteMemberResponse, { _member: _member }).fromJSON;
    function __unmuteMember(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.member',
            method: 'POST',
            methodFqn: 'com.wixpress.members.api.Members.UnmuteMember',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersApiMembersUrl({
                protoPath: '/v1/members/{id}/unmute',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __unmuteMember.fromReq = fromReq;
    __unmuteMember.__isAmbassador = true;
    return __unmuteMember;
}
/**
 * Changes member status to `"APPROVED"` and gives access to members-only pages.
 *
 * Call this API to:
 * - Approve a pending member.
 * - Unblock a blocked member.
 */
export function approveMember(payload) {
    var _a = serializer(_approveMemberRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_approveMemberResponse, { _member: _member }).fromJSON;
    function __approveMember(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.member',
            method: 'POST',
            methodFqn: 'com.wixpress.members.api.Members.ApproveMember',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersApiMembersUrl({
                protoPath: '/v1/members/{id}/approve',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __approveMember.fromReq = fromReq;
    __approveMember.__isAmbassador = true;
    return __approveMember;
}
/**
 * Blocks a member.
 *
 * A blocked member can't log in to members-only pages.
 *
 * To unblock a member, call Approve Member.
 */
export function blockMember(payload) {
    var _a = serializer(_blockMemberRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_blockMemberResponse, { _member: _member }).fromJSON;
    function __blockMember(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.member',
            method: 'POST',
            methodFqn: 'com.wixpress.members.api.Members.BlockMember',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersApiMembersUrl({
                protoPath: '/v1/members/{id}/block',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __blockMember.fromReq = fromReq;
    __blockMember.__isAmbassador = true;
    return __blockMember;
}
/**
 * Disconnects a member.
 *
 * A disconnected member can't log in to members-only pages, and the member isn't visible in the dashboard.
 *
 * >**Note:** This action is irreversible. To connect the same member again, you have to create a member with a new slug.
 */
export function disconnectMember(payload) {
    var _a = serializer(_disconnectMemberRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_disconnectMemberResponse, {
        _member: _member,
    }).fromJSON;
    function __disconnectMember(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.member',
            method: 'POST',
            methodFqn: 'com.wixpress.members.api.Members.DisconnectMember',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersApiMembersUrl({
                protoPath: '/v1/members/{id}/disconnect',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __disconnectMember.fromReq = fromReq;
    __disconnectMember.__isAmbassador = true;
    return __disconnectMember;
}
/**
 * Deletes a member by ID.
 *
 * All content created by this member is transferred to a site owner's account. For example, if a Wix user had blog posts, those posts are transferred to the site owner's account, which then becomes the owner of those posts.
 */
export function deleteMember(payload) {
    var _a = serializer(_deleteMemberRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteMemberResponse, {}).fromJSON;
    function __deleteMember(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.member',
            method: 'DELETE',
            methodFqn: 'com.wixpress.members.api.Members.DeleteMember',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersApiMembersUrl({
                protoPath: '/v1/members/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteMember.fromReq = fromReq;
    __deleteMember.__isAmbassador = true;
    return __deleteMember;
}
/**
 * Deletes the current member.
 *
 * After calling this method, the member is logged out of the site.
 *
 * All content created by this member is transferred to another account. For example, if a Wix user had blog posts, those posts are transferred to the account specified in `contentAssignedId`, which then becomes the owner of those posts.
 *
 * >**Note:**
 * >This method requires [visitor or member authentication](https://dev.wix.com/docs/build-apps/develop-your-app/access/about-identities).
 */
export function deleteMyMember(payload) {
    var _a = serializer(_deleteMyMemberRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteMyMemberResponse, {}).fromJSON;
    function __deleteMyMember(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.member',
            method: 'DELETE',
            methodFqn: 'com.wixpress.members.api.Members.DeleteMyMember',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersApiMembersUrl({
                protoPath: '/v1/members/my',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteMyMember.fromReq = fromReq;
    __deleteMyMember.__isAmbassador = true;
    return __deleteMyMember;
}
/**
 * Deletes multiple members by `memberId`.
 *
 * All content created by these members is transferred to a site owner's account. For example, if Wix users had blog posts, those posts are transferred to the site owner's account, which then becomes the owner of those posts.
 */
export function bulkDeleteMembers(payload) {
    var _a = serializer(_bulkDeleteMembersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkDeleteMembersResponse, {}).fromJSON;
    function __bulkDeleteMembers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.member',
            method: 'POST',
            methodFqn: 'com.wixpress.members.api.Members.BulkDeleteMembers',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersApiMembersUrl({
                protoPath: '/v1/members/bulk/delete',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkDeleteMembers.fromReq = fromReq;
    __bulkDeleteMembers.__isAmbassador = true;
    return __bulkDeleteMembers;
}
/**
 * Deletes multiple members by the specified filter.
 *
 * All content created by these members is transferred to a site owner's account. For example, if Wix users had blog posts, those posts are transferred to the site owner's account, which then becomes the owner of those posts.
 */
export function bulkDeleteMembersByFilter(payload) {
    var _a = serializer(_bulkDeleteMembersByFilterRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkDeleteMembersByFilterResponse, {}).fromJSON;
    function __bulkDeleteMembersByFilter(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.member',
            method: 'POST',
            methodFqn: 'com.wixpress.members.api.Members.BulkDeleteMembersByFilter',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersApiMembersUrl({
                protoPath: '/v1/members/bulk/delete-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkDeleteMembersByFilter.fromReq = fromReq;
    __bulkDeleteMembersByFilter.__isAmbassador = true;
    return __bulkDeleteMembersByFilter;
}
/**
 * Changes status of multiple members to `"APPROVED"`, and gives access to members-only pages.
 *
 * Call this API to:
 * - Approve pending members.
 * - Unblock blocked members.
 */
export function bulkApproveMembers(payload) {
    var _a = serializer(_bulkApproveMembersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkApproveMembersResponse, {}).fromJSON;
    function __bulkApproveMembers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.member',
            method: 'POST',
            methodFqn: 'com.wixpress.members.api.Members.BulkApproveMembers',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersApiMembersUrl({
                protoPath: '/v1/members/bulk/approve-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkApproveMembers.fromReq = fromReq;
    __bulkApproveMembers.__isAmbassador = true;
    return __bulkApproveMembers;
}
/**
 * Blocks multiple members by a specified filter.
 *
 * Blocked members can't log in to members-only pages.
 *
 * To unblock multiple members, call Bulk Approve Members.
 */
export function bulkBlockMembers(payload) {
    var _a = serializer(_bulkBlockMembersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkBlockMembersResponse, {}).fromJSON;
    function __bulkBlockMembers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.member',
            method: 'POST',
            methodFqn: 'com.wixpress.members.api.Members.BulkBlockMembers',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersApiMembersUrl({
                protoPath: '/v1/members/bulk/block-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkBlockMembers.fromReq = fromReq;
    __bulkBlockMembers.__isAmbassador = true;
    return __bulkBlockMembers;
}
/**
 * Creates a site member.
 *
 * After creation, you can call
 * [Send Set Password Email ([SDK](https://dev.wix.com/docs/sdk/backend-modules/members/authentication/send-set-password-email) | [REST](https://dev.wix.com/docs/rest/crm/members-contacts/members/member-authentication/send-set-password-email))
 * to email the member with a link to set their password.
 * The member can log in to the site
 * when they set their password for the first time.
 *
 * > **Note:**
 * > When creating multiple members,
 * > set your requests at least 1 second apart to keep below rate limits.
 */
export function createMember(payload) {
    var _a = serializer(_createMemberRequest, { _member: _member }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createMemberResponse, { _member: _member }).fromJSON;
    function __createMember(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.member',
            method: 'POST',
            methodFqn: 'com.wixpress.members.api.Members.CreateMember',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersApiMembersUrl({
                protoPath: '/v1/members',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createMember.fromReq = fromReq;
    __createMember.__isAmbassador = true;
    return __createMember;
}
/**
 * Updates a member's properties.
 *
 * Members are typically associated with a contact, each having a distinct member ID and contact ID. When specifying the ID as a parameter, don't presume the IDs are identical since they represent separate entities.
 *
 * `privacyStatus` can't be updated with Update Member. A member can call Leave Community or Join Community to update their `privacyStatus`.
 *
 * To clear a field's value, set an empty value with an empty string `""`.
 *
 * Note that updating the `contact.addresses`, `contact.emails`, or `contact.phones` array overwrites
 * the entire array, so any existing values you want to retain should be specified in the Update Member call
 * along with the new values to add. However, passing an empty array will have no effect and the following
 * methods must be called to clear all the data from these respective arrays:
 * - To clear `contact.addresses`, call Delete Member Addresses.
 * - To clear `contact.emails`, call Delete Member Emails.
 * - To clear `contact.phones`, call Delete Member Phones.
 */
export function updateMember(payload) {
    var _a = serializer(_updateMemberRequest, { _member: _member }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateMemberResponse, { _member: _member }).fromJSON;
    function __updateMember(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.member',
            method: 'PATCH',
            methodFqn: 'com.wixpress.members.api.Members.UpdateMember',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersApiMembersUrl({
                protoPath: '/v1/members/{member.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateMember.fromReq = fromReq;
    __updateMember.__isAmbassador = true;
    return __updateMember;
}
/**
 * Clears a member's phone numbers.
 *
 * Members are typically associated with a contact, each having a distinct member ID and contact ID. When specifying the ID as a parameter, don't presume the IDs are identical since they represent separate entities.
 */
export function deleteMemberPhones(payload) {
    var _a = serializer(_deleteMemberPhonesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteMemberPhonesResponse, {
        _member: _member,
    }).fromJSON;
    function __deleteMemberPhones(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.member',
            method: 'DELETE',
            methodFqn: 'com.wixpress.members.api.Members.DeleteMemberPhones',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersApiMembersUrl({
                protoPath: '/v1/members/{id}/phones',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteMemberPhones.fromReq = fromReq;
    __deleteMemberPhones.__isAmbassador = true;
    return __deleteMemberPhones;
}
/**
 * Clears a member's email addresses.
 *
 * Members are typically associated with a contact, each having a distinct member ID and contact ID. When specifying the ID as a parameter, don't presume the IDs are identical since they represent separate entities.
 *
 * > Note: A member can still log in with their `loginEmail`, which is not cleared when this method is called.
 */
export function deleteMemberEmails(payload) {
    var _a = serializer(_deleteMemberEmailsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteMemberEmailsResponse, {
        _member: _member,
    }).fromJSON;
    function __deleteMemberEmails(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.member',
            method: 'DELETE',
            methodFqn: 'com.wixpress.members.api.Members.DeleteMemberEmails',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersApiMembersUrl({
                protoPath: '/v1/members/{id}/emails',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteMemberEmails.fromReq = fromReq;
    __deleteMemberEmails.__isAmbassador = true;
    return __deleteMemberEmails;
}
/**
 * Clears a member's street addresses.
 *
 * Members are typically associated with a contact, each having a distinct member ID and contact ID. When specifying the ID as a parameter, don't presume the IDs are identical since they represent separate entities.
 */
export function deleteMemberAddresses(payload) {
    var _a = serializer(_deleteMemberAddressesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteMemberAddressesResponse, {
        _member: _member,
    }).fromJSON;
    function __deleteMemberAddresses(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.members.v1.member',
            method: 'DELETE',
            methodFqn: 'com.wixpress.members.api.Members.DeleteMemberAddresses',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressMembersApiMembersUrl({
                protoPath: '/v1/members/{id}/addresses',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteMemberAddresses.fromReq = fromReq;
    __deleteMemberAddresses.__isAmbassador = true;
    return __deleteMemberAddresses;
}
//# sourceMappingURL=http.impl.js.map